import React from 'react';
import { Helmet } from 'react-helmet-async';
import Hero from './Hero/Hero';
import PrivacyBody from './PrivacyBody/PrivacyBody';

const Recruitmentfraud = () => {

    return (
        <div className="privacy-view">
            <Helmet>
                <title>HPP&apos;s Recruitment Fraud | Hudson Pacific Properties</title>
                <meta name="description" property="og:description" content="Read Hudson Pacific Properties a Notice on Recruitment Scams here." />
            </Helmet>
            <Hero />
            <PrivacyBody />
        </div>
    );
};

export default Recruitmentfraud;
